import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-05-29'
        tag='Grailed'
        title='Grailed Seller Guide: 5 Tips To Avoid Getting Scammed'
      >
        <p>
          Anyone can easily create accounts and buy and sell on e-commerce sites. But with anonymity comes the risk of
          getting scammed. Whether you are a buyer or seller, certain users take advantage of others for different
          reasons.
        </p>
        <p>
          On Grailed, the menswear-focused online marketplace is where you can scour for high-quality pieces, new and
          pre-loved. However, given there are vintage, branded, and designer clothing and accessories, scammers are
          bound to infiltrate the site in hopes of swindling users. While this may be daunting, there are a few
          practical tips to avoid turning into one of the victims.
        </p>

        <h3>Common Scams</h3>
        <p>
          Even veteran sellers can fall into the trap of fraud. Some users are getting creative and strategic with how
          they scam people. Here are some of the usual types of rackets present in online selling.
        </p>

        <h4>The buyer claims order wasn’t shipped.</h4>
        <p>
          There are cases when no matter how carefully you packed the order, the buyer would claim they never received
          it. Be wary when you receive such a message. Scammers do this so they can keep the item that they indeed
          receive. They pretend nothing arrived, so you would be forced to pack and ship a similar item. In turn, they
          now have two of their original orders they got for free.
        </p>

        <h4>The buyer complains order is different from the listing.</h4>
        <p>
          Taking and posting high-quality photos are crucial on Grailed and any other e-commerce site/app. This is
          because scammers can claim they received an item different from the one you posted. It can be the color, the
          material or texture of the clothing, the brand, and any other elements. They do this to pressure you to send
          the “correct” item. As a result, the scammer would have an additional order for “free.”
        </p>

        <h4>The buyer wants a chargeback or a refund.</h4>
        <p>
          Take note that not all disputes in online selling can be resolved with refunds. Sellers must be cautious in
          discussing with a buyer who wants their money back. They may be scammers who assert they received a “damaged”
          item. However, in reality, they inflicted a minor defect on the item so they can force you to give their
          payment back.
        </p>

        <h4>The buyer insists on an offsite transaction.</h4>
        <p>
          As much as possible, make all payments on Grailed and PayPal. Otherwise, these two platforms will be unable to
          protect you and your items from fraudulent transactions. The latter happens when a Grailed user demands to pay
          via another website or app. Typically, there could be additional charges if you transact with them, especially
          on third-party websites.
        </p>
        <p>
          Offsite also includes meet-ups. For some sellers, meet-ups are more convenient, especially when you and the
          buyer live nearby. It is also easier to check for any damages on the orders and deal with the issue right
          away. However, be careful as you are still transacting with a stranger. They may scam you by not showing up at
          the agreed meeting place, or worse, they have other intentions by requesting to receive the order from you
          personally. Always be vigilant of transactions outside of Grailed and PayPal.
        </p>

        <h3>Tips To Avoid Scams</h3>
        <p>
          Navigating the reselling business is challenging, especially when you also have to look out for possible
          fraudulent activity. Here are effective ways to avoid scams and enjoy growing your business and closing more
          sales.
        </p>

        <h4>1. Start selling low-priced items.</h4>
        <p>
          While you would want to sell branded or designer items right away to gain profit, you have to start slow and
          low. If you are a new seller, do listings for clothing and accessories that are not worth a lot. These can be
          under $50 or under $100. Doing so steers you away from the radar of scammers who take advantage of those
          selling expensive pieces.
        </p>
        <p>
          Selling these low-priced items will help you gain the trust of Grailed users as you close more sales. Getting
          positive feedback from them is crucial so you can build your reputation. More potential buyers will flock to
          you once you have become a trusted seller.
        </p>
        <p>
          This is the time when you start releasing high-end pieces. After all, buyers tend to be wary of newbie sellers
          who list costly items. They have yet to earn the confidence of Grailed users to purchase from them. This is a
          given as there are also scammer sellers on e-commerce sites.
        </p>

        <h4>2. Take high-quality photos</h4>
        <p>
          Uploading clear photos is essential to avoid scammers claiming the items they received have defects–no matter
          how minor they are (e.g., scratches). Make sure you take photos of the clothing, shoes, or accessories under
          natural light. This makes the material, texture, elements, designs, and other parts of the item highly
          visible. Also, include close-ups so that the potential customer is aware of what the item looks like before
          they purchase it.
        </p>
        <p>
          Before uploading, check if the photos are high-quality or clear. You don’t need a professional camera for
          this. Even your smartphone can capture the overall look and details of the item. Simply make sure the image is
          not blurry, grainy, or faded. Do not add any filters or effects to the photos. Otherwise, you are running the
          risk of the buyer complaining the color or other aspects of the item are not similar to how you displayed and
          described it.
        </p>

        <h4>3. Be transparent in your description.</h4>
        <p>
          Honesty about the items you sell always gains the trust of potential customers. Indicating the actual
          condition of the item, especially the flaw, gives users the option of whether or not to push through with the
          purchase. People like knowing the overall condition of items they are about to order, no matter how minor the
          detail is.
        </p>
        <p>
          Be sure to state the measurements as well. This is to avoid buyers claiming the clothing or shoes are too
          small or too huge, and then they would demand a replacement or refund.{' '}
        </p>
        <p>
          Remember, it is always better to overexplain and include as many details as possible than take the risk of
          getting scammed.
        </p>

        <h4>4. Double-check shipping address</h4>
        <p>
          Take that extra time to review the buyer’s address indicated on their purchase order or PayPal transaction.
          This is to avoid incorrect deliveries by the courier (e.g., shipped to the wrong address). Also, you should
          provide a valid tracking number to Grailed and PayPal so both platforms can cover the order should anything
          happen to it.
        </p>

        <h4>5. Take additional steps for protection.</h4>
        <p>
          You can film yourself packing up the orders for an extra layer of security. Send this to the buyer afterward
          before shipping. In this way, you can assure them that you packaged the correct items securely and as is or
          how it appears on the listing.
        </p>
        <p>
          Aside from providing reassurance to them, filming also protects you from possible scammers that complain about
          damaged or incorrect items, thereby demanding a refund.
        </p>

        <h3>Grow Your Business Easier</h3>
        <p>
          With many aspects of the reselling business, you may find it daunting to commit to it. Even searching for ways
          to increase your sales can be difficult on top of managing your existing orders.
        </p>
        <p>
          OneShop is a great automation service that can help you grow your business. You can crosslist your items to
          other ecommerce platforms in this app, giving it more exposure to thousands of other potential customers. The
          app also automatically delists once an item has been sold to avoid selling it twice to different buyers.
        </p>
        <p>
          On Grailed, these features are not yet available. In the meantime, you can track your sales and see how you
          are growing. This is also useful for checking if everything is accounted for to avoid scams.
        </p>
        <p>
          <a href='https://tools.oneshop.com/signup'>Sign up on OneShop</a> and avail of its 7-day free trial. You can
          experience how an automation service makes managing your business easier and faster. The app has helped
          thousands of other resellers, and you can be one of them today.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
